import * as React from "react";
import styles from "./ErrorBoundary.module.css";
import {ReactComponent as Error404} from "../svg/error404.svg";
import {ReactComponent as ExclamationFillIcon} from "../svg/exclamation-fill.svg";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {hasError: false, error: null, errorInfo: null};
    }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {hasError: true};
    }

    refresh() {
        // localStorage.clear();
        // sessionStorage.clear();
        if (!process.env.REACT_APP_DEV_MODE === "DEV") {
            // if (caches) {
            //     caches.keys().then((names) => {
            //         names.forEach((name) => {
            //             caches.delete(name).then(() => null);
            //         });
            //     });
            // }
            window.location.reload(true);
            // window.location.replace(window.location.origin)
        }
    }

    componentDidCatch(error, errorInfo) {

        this.setState({...this.state, error: error, errorInfo: errorInfo});

        // NavigatorController.unregister();

        // You can also log the error to an error reporting service
        localStorage.setItem("error", JSON.stringify(error));
        localStorage.setItem("errorInfo", JSON.stringify(errorInfo));
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            if (process.env.REACT_APP_DEV_MODE === "DEV") {
                return (
                    <div className="reload-page">
                        <Error404 className={styles.image}/>
                        <h1 className={styles.alert}>
                            {navigator?.onLine ? "Please check internet connection!" : "Something went wrong."}
                        </h1>
                        {navigator?.onLine && <p
                            className="json"
                            dangerouslySetInnerHTML={{
                                __html: JSON.stringify(
                                    this.state.error,
                                    null,
                                    4
                                ).replaceAll("\n", `<br/>`),
                            }}
                        />}
                        {navigator?.onLine && <p
                            className="json"
                            dangerouslySetInnerHTML={{
                                __html: JSON.stringify(
                                    this.state.errorInfo,
                                    null,
                                    4
                                ).replaceAll("\n", `<br/>`),
                            }}
                        />}

                        <button
                            className={styles.button}
                            onClick={this.refresh}
                        >
                            Reload Website
                        </button>
                    </div>
                );
            } else {

                return (
                    <div className={styles.page}>

                        <Error404 className={styles.image}/>
                        <h1 className={styles.alert}>
                            <ExclamationFillIcon className={styles.iconMargin}/>
                            Please check internet connection!
                        </h1>

                    </div>
                )

            }
        }
        return this.props.children;
    }
}
